import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { AuthService } from '../../shared/services/auth.service';

@Component({
  selector: 'app-impersonation-banner',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './impersonation-banner.component.html',
  styleUrls: ['./impersonation-banner.component.scss'],
})
export class ImpersonationBannerComponent {
  constructor(public authService: AuthService) {}

  public onLeaveSession(): void {
    this.authService.logout();
  }

  get displayName(): string {
    const user = this.authService.getUserData();
    if (!user) return 'User';
    const first = user.first_name ?? '';
    const last = user.last_name ?? '';
    const full = [first, last].filter(Boolean).join(' ');
    return full || user.email || 'User';
  }

  get userEmail(): string | null {
    const user = this.authService.getUserData();
    return user?.email ?? null;
  }

  /** Display role for the account owner (e.g. "Manager", "User"). */
  get accountOwnerRoleLabel(): string {
    return this.authService.getAccountOwnerRoleLabel();
  }

  get connectedAdmin(): { name: string; email: string } | null {
    const p = this.authService.getImpersonator();
    return p ? { name: p.name, email: p.email } : null;
  }
}
